export function objToParams (obj = {}, s = '?') {
  return Object.keys(obj).reduce(
    (str, key, index) =>
      (str += (index === 0 ? s : '&') + key + '=' + obj[key]),
    ''
  )
}

export const arrToOptions = (arr) =>
  arr.map((item) => ({ label: item, value: item }))

export const objToOptions = (obj) =>
  Object.entries(obj).map((item) => ({ value: item[0], label: item[1] }))

export const arrToObj = (arr) =>
  arr.reduce((obj, key) => ({ ...obj, [key]: '' }), {})

export const filterArr = (arr1, arr2) =>
  arr1.filter((item) => !arr2.includes(item))

export const uniqBy = (arr = [], key) => [
  ...new Map(arr.map((item) => [item[key], item])).values()
]

export const getValue = (obj, v = 'inputValue') =>
  Object.keys(obj).reduce((o, key) => ({ ...o, [key]: obj[key][v] }), {})

export const getLabel = (obj) =>
  obj.options.filter((item) => item.value === obj.inputValue)[0]?.label ||
  obj.inputValue

export const getTableLabel = (arr, key) =>
  arr.find((item) => item.prop === key).label

export const arrToObjByKey = (arr = [], key) =>
  arr.reduce(
    (obj, item) => ({
      [item[key]]: obj[item[key]] ? obj[item[key]].push(item) : [item],
      ...obj
    }),
    {}
  )
